// Modules
// Material-ui
import { styled } from '@mui/material/styles';
import Button, { buttonClasses } from '@mui/material/Button';

// Helpers
import { COLORS } from '@/lib/helpers';

// Components
// Common components

const SecondaryTextLink = styled(Button)(({ theme }) => ({
  padding: '0.375rem 0.75rem',
  borderRadius: '2px',
  color: theme.mainColor,
  backgroundColor: 'transparent',
  border: 'none',
  textTransform: 'none',
  '&:hover': {
    color: theme.mainColorDark,
    backgroundColor: 'transparent',
    '& .MuiButton-startIcon, & .MuiButton-endIcon': {
      color: theme.mainColorDark,
    },
  },
  '&.MuiButton-sizeSmall': {
    padding: '0.25rem 0.5rem',
  },
  '&.MuiButton-sizeLarge': {
    padding: '0.5rem 1rem',
  },
  '&.Mui-disabled': {
    color: COLORS.GRAY_SHADE_40,
    '& .MuiButton-startIcon, & .MuiButton-endIcon': {
      color: `${COLORS.GRAY_SHADE_40} !important`,
    },
  },
  [`& .${buttonClasses.startIcon}`]: {
    color: theme.mainColor,
  },
  [`& .${buttonClasses.endIcon}`]: {
    color: theme.mainColor,
  },
  '&.Mui-focusVisible': {
    outline: `solid ${theme.mainColor}`,
    outlineOffset: '2px',
  },
}));

export default SecondaryTextLink;
